import { request } from './request';

export interface ReleaseNotesData {
  id: number;
  title: string;
  content: string;
  platform: string;
  created: Date;
  modified: Date;
  published: boolean;
}

export interface PaginatedResponse<T> {
  count: number;
  next?: any;
  previous?: any;
  results: T[];
}

export const releaseNotesList = (
  limit: number = 10,
  offset: number = 0
): Promise<PaginatedResponse<ReleaseNotesData>> => {
  let url = `/api/changelog/release-notes/?limit=${limit}&offset=${offset}`;

  return request('GET', url, {}, { injectTenant: false, version: 1 });
};

export interface ReleaseNotesStatus {
  has_unseen: boolean;
  latest_created: string | null;
}

// Whether the user has published WEB release notes newer than the ones they last viewed. Drives
// the "What's new" menu marker.
export const releaseNotesStatus = (): Promise<ReleaseNotesStatus> => {
  return request(
    'GET',
    '/api/changelog/release-notes/status/',
    {},
    { injectTenant: false, version: 1, skipErrorResponseHandling: true }
  );
};

// Record that the user has seen the release notes up to the latest WEB note (clears the marker).
export const releaseNotesMarkSeen = (): Promise<void> => {
  return request('POST', '/api/changelog/release-notes/mark-seen/', {}, { injectTenant: false, version: 1 });
};
